import * as React from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" }));
export default SvgChevronRight;
